<onyx-section [heading]="heading()">
  <form [formGroup]="form()" [onyxAutoFocus]="mode()">
    @if (showNewAddressMessage()) {
      <onyx-message intent="information">
        <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

        <p>{{ `${I18N}.newAddress` | translate }}</p>
      </onyx-message>
    }

    @let controls = form().controls;

    <onyx-address-input
      [formControl]="controls.address"
      label="labels.address"
      [showApartment]="true"
      apartmentWidth="calc(110/748 * 100%)"
      (nameChange)="setName($event)"
      [size]="32"
    ></onyx-address-input>

    <onyx-text-field
      [formControl]="controls.name"
      [label]="name()"
      [size]="32"
    ></onyx-text-field>

    <onyx-map></onyx-map>
  </form>
</onyx-section>
